import { Component, effect } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { genericProfileImg } from '@/services/data/generic-profile';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { PermRole } from '@/models/user-data.model';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { InviteService } from '@/services/api/invite.service';
interface InviteRole {
  inviteId: number,
    roleId: number,
    inviteRoleId: number,
    PermRoles: PermRole
}

@Component({
  selector: 'app-invite-review',
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    MessageModule
  ],
  template: `
  <div class="flex-col" *ngIf="invite">
    <h3 *ngIf="invite.Users_officeInvites_senderToUsers">{{invite.Users_officeInvites_senderToUsers.DisplayName}} invited you to the following roles:</h3>
    <div *ngFor="let office of sortedRoles">
<div class="grid m-1" *ngIf="office.Roles">
    <div *ngFor="let role of office.Roles" [ngClass]="'col-12 md:col-6 xl:col-4 p-3 grid-container'">
        <p-card class="no-c-padding">
            <ng-template pTemplate="header">
                <div class="flex justify-content-between align-items-center pl-2">
                    <span class="text-900 text-xl font-bold">{{role.RoleName}}</span>
                </div>
                <div class="flex justify-content-between align-items-center pl-2">
                    <span class="text-500 font-bold">{{office.CityCode}} office</span>
                </div>
            </ng-template>
                <ul class="list-none mx-0 mb-1 mt-1 p-0">
                    <li class="flex align-items-start p-1" *ngFor="let permission of role.Access">
                        
                        <i class="bg-green-500 text-white border-circle border-1 p-1 surface-border pi pi-check mr-2" style="font-size: 1rem"></i>
                        <span class="text-500 line-height-2" style="font-size: 1rem">{{renderPermDesc(permission.table, permission.perms)}}</span>
                    </li>
                </ul>
        </p-card>
    </div>
</div>
</div>
<div class="button-container">
    <button *ngIf="invite.response ===null" pButton type="button" label="Decline Invite" (click)="declineInvite()" class="ml-auto"></button>
    <button [disabled]="invite.response !==null" pButton type="button" [label]="invite.response ===true ? 'Invite Already Accepted' : invite.response ===false ? 'Invite Already Declined' : 'Accept Invite'" (click)="acceptInvite()" class="ml-auto"></button>
</div>
</div>
<div *ngIf="!invite" class="flex justify-content-center align-items-center" style="padding: 5rem;">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
</div>
  `,
  styles: `
.button-container {
    display: flex;
    justify-content:flex-end;
    align-items: center;
    position: sticky;
    bottom: 0;
    padding: 1em; /* Optional: add some padding */
  }
  `
})
export class InviteReviewComponent {
  sortedRoles: { CityCode: string; Roles: { RoleName: string; Access: { table: string; perms: string[]; }[]; }[]; }[] = [];
  inviteId: number | null = null;
  invite: any | null = null;
  inviteSubscription!: Subscription;
  genericPersonImage64: string = genericProfileImg;

  constructor(
    private inviteService: InviteService, 
    private router: Router,
    private binderDialogService: BinderDialogService,
    private messageService: MessageService
  ) {
effect(() => {
  this.inviteId = this.inviteService.inviteId();
  if(this.inviteId) {
    this.inviteService.getInvite(this.inviteId).subscribe(invite => {
      this.invite = invite;
      this.sortRoles(this.invite.inviteRoles);
    });
  }
  });
  }

  camelCaseToTitleCase(camelCase: string): string {
    return camelCase
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter
  }

  convertToList(perms: string[]): string {
    if (perms.length === 0) return '';
    if (perms.length === 1) return perms[0];
    return perms.slice(0, -1).join(', ') + ' & ' + perms[perms.length - 1];
  }

  renderPermDesc(table:string, perms: string[]) {
    const tableString = this.camelCaseToTitleCase(table);
    const permString = this.convertToList(perms);
    return `Can ${permString} ${tableString}`;
  }

  sortRoles(roles: InviteRole[]) {
    if (!roles) return;

    const groupedRoles = new Map<string, { RoleName: string; Access: { table: string; perms: string[] }[] }[]>();

    roles.forEach(role => {
      const cityCode = role.PermRoles.Franchises?.Title || "Corporate";
      if (!groupedRoles.has(cityCode)) {
        groupedRoles.set(cityCode, []);
      }
      
      const roleName = role.PermRoles.RoleName || "Unknown Role";
      const accessMap = new Map<string, string[]>();

      role.PermRoles.RoleAccess?.forEach((access: any) => {
        const module = access.AccessPermissions.dataTable;
        const action = access.AccessPermissions.permType;

        if (!accessMap.has(module)) {
          accessMap.set(module, []);
        }
        accessMap.get(module)!.push(action);
      });

      const accessArray = Array.from(accessMap.entries()).map(([table, perms]) => ({
        table,
        perms
      }));

      groupedRoles.get(cityCode)!.push({
        RoleName: roleName,
        Access: accessArray
      });
    });

    this.sortedRoles = Array.from(groupedRoles.entries()).map(([cityCode, roles]) => ({
      CityCode: cityCode,
      Roles: roles
    }));

    console.log('sortedRoles', this.sortedRoles);
}

  acceptInvite() {
    if(this.inviteId) {
      console.log('accepting invite');
    this.inviteService.acceptInvite(this.inviteId).subscribe(res => {
      console.log('invite accepted', res);
      this.messageService.add({severity:'success', summary: 'Invite Accepted', detail: 'You have accepted the invite'});
      this.binderDialogService.toggleDialog('Invite', 'invite', false);
      this.router.navigate(['/']);
    },
    error => {
      this.messageService.add({severity:'error', summary: 'Accept Failed', detail: 'An Error Occurred'});
    }
  
  );
    }
  }

  declineInvite() {
    if(this.inviteId) {
      console.log('declining invite');
    this.inviteService.declineInvite(this.inviteId).subscribe(res => {
      console.log('invite declined', res);
      this.messageService.add({severity:'success', summary: 'Invite Declined', detail: 'You have declined the invite'});
      this.binderDialogService.toggleDialog('Invite', 'invite', false);
      this.router.navigate(['/']);
    },
    error => {
      this.messageService.add({severity:'error', summary: 'Decline Failed', detail: 'An Error Occurred'});
    }
  
  );
    }
  }

}
